import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export const operatorApiPlatformApi = {
  getApiPlatformUsage: (params?: Record<string, unknown>) =>
    api.get<ApiResponse<any[]>>('/operator/api-platform/usage', { params }),

  listRequestLogs: (params?: Record<string, unknown>) =>
    api.get<ApiResponse<any>>('/operator/api-platform/request-logs', { params }),
};
